module.exports = __webpack_public_path__ + "img/camryn-garrett.a5e112d4.png";